import { TRANS } from "./classes";
import { DefaultIfEmptyString } from "./classes";
import { NullValueDefiner } from "./classes";
import { CMP } from "../util/cmp";

export class SMART_CMP {
    private static is_number_v1(p_str: string): boolean {

        const str: string = p_str.trim();

        if (str == "") {
            return false;
        }

        return isNaN(Number(str)) == false;
    }

    private static is_boolean_v1(p_str: string): boolean {

        const str: string = p_str.trim().toLowerCase();

        return str == "true" ||
            str == "false" ||
            str == "כן" ||
            str == "לא";
    }

    private static is_daton_v1(p_str: string): boolean {

        const pattern: RegExp = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

        return pattern.test(p_str.trim());
    }

    private static is_homin_v1(p_str: string): boolean {

        const pattern: RegExp = /^\d{2}:\d{2}$/;

        return pattern.test(p_str.trim());
    }

    private static is_percentage_v1(p_str: string): boolean {

        const str: string = p_str.trim();

        if (str.length == 0) {
            return false;
        }

        if (str.charAt(str.length - 1) != "%") {
            return false;
        }

        const number_as_str: string =
            str.substring(0, str.length - 1).trim();

        if (number_as_str == "") {
            return false;
        }

        return isNaN(Number(number_as_str)) == false;
    }

    private static is_ratio_v1(p_str: string): boolean {

        const str: string = p_str.trim();
        const parts: string[] = str.split("/");

        if (parts.length != 2) {
            return false;
        }

        if (SMART_CMP.is_number_v1(parts[0]) == false) {
            return false;
        }

        if (SMART_CMP.is_number_v1(parts[1]) == false) {
            return false;
        }

        return true;
    }

    public static COMPARE(p_str1: string, p_str2: string, p_NULL_IS_UP: boolean): number {
        if (SMART_CMP.is_number_v1(p_str1) == true && SMART_CMP.is_number_v1(p_str2) == true) {
            const cmp_result = CMP.compare_numbers_as_strings(p_str1, p_str2, p_NULL_IS_UP);
            return cmp_result;
        }
        if (SMART_CMP.is_boolean_v1(p_str1) == true && SMART_CMP.is_boolean_v1(p_str2) == true) {
            const cmp_result = CMP.compare_booleans_as_strings(p_str1, p_str2, p_NULL_IS_UP);
            return cmp_result;
        }
        if (SMART_CMP.is_daton_v1(p_str1) == true && SMART_CMP.is_daton_v1(p_str2) == true) {
            const cmp_result = CMP.compare_datons_V1_as_strings(p_str1, p_str2, p_NULL_IS_UP);
            return cmp_result;
        }
        if (SMART_CMP.is_homin_v1(p_str1) == true && SMART_CMP.is_homin_v1(p_str2) == true) {
            const cmp_result = CMP.compare_homins_V1_as_strings(p_str1, p_str2, p_NULL_IS_UP);
            return cmp_result;
        }
        if (SMART_CMP.is_percentage_v1(p_str1) == true && SMART_CMP.is_percentage_v1(p_str2) == true) {
            const cmp_result = CMP.compare_percentages_as_strings(p_str1, p_str2, p_NULL_IS_UP);
            return cmp_result;
        }
        if (SMART_CMP.is_ratio_v1(p_str1) == true && SMART_CMP.is_ratio_v1(p_str2) == true) {
            const cmp_result = CMP.compare_ratios_as_strings(p_str1, p_str2, p_NULL_IS_UP);
            return cmp_result;
        }
        return CMP.compare_strings(p_str1, p_str2, false);
    }

}

